import React from "react";
import {Box, Text, Stack, Switch, useMantineColorScheme} from "@mantine/core";
import classes from "./SoftwarePanel.module.css";

export interface PreferencesPanelProps {
}

export const PreferencesPanel: React.FC<PreferencesPanelProps> = () => {
    const {setColorScheme, colorScheme} = useMantineColorScheme();

    return (
        <Box className={classes.root}>
            <Stack gap="md">
                <Text>Color Scheme</Text>
                <Switch
                    checked={colorScheme === "light"}
                    label={<Text
                        c={"var(--bios-color-text"}>{colorScheme === "light" ? "Light Mode" : "Dark Mode"}</Text>}
                    onChange={(event) => {
                        setColorScheme(event.currentTarget.checked ? "light" : "dark")
                    }}
                />
                <Box style={{borderBottom:"var(--bios-border)"}}/>
            </Stack>
        </Box>
    );
};